import { ImagePosition } from "constants/notebooks/image-position";
import { ImageSize } from "constants/notebooks/image-size";
import { useMemo } from "react";
import { Breakpoints } from "utilities/enumerations/breakpoints";
import useBreakpoint, {
    BreakpointComparer,
} from "utilities/hooks/use-breakpoint";

export const useImageStyles = (size?: ImageSize, position?: ImagePosition) => {
    const isMobile = useBreakpoint(
        Breakpoints.Phone,
        BreakpointComparer.MaxWidth
    );

    const sizeOrDefault = useMemo(
        () => size ?? (isMobile ? ImageSize.Small : ImageSize.Medium),
        [size, isMobile]
    );
    const positionOrDefault = useMemo(
        () => position ?? ImagePosition.Center,
        [position]
    );

    return {
        sizeOrDefault,
        positionOrDefault,
    };
};
